import RoutableTabs from './RoutableTabs';

export default RoutableTabs;
